import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from "prop-types";
import { Route } from 'react-router-dom';


const ProdectedRouter = ({ component: Component, ...rest }) => {
    const isAuthenticated = localStorage.getItem('isauth') === 'true';
    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthenticated ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/login" />
                )
            }
        />
    );

};

ProdectedRouter.propTypes = {
    component: PropTypes.elementType.isRequired,
    children: PropTypes.node, // Validate children as a node (any valid React child)
};

export default ProdectedRouter;